import { createContext } from "react";
import { NavAction, NavState } from "./reducer";

export const NavContext = createContext<[NavState, React.Dispatch<NavAction>]>(undefined);
